import { useCallback, useRef } from 'react';

interface LongPressHandlers {
  onTouchStart: (e: React.TouchEvent) => void;
  onTouchEnd: () => void;
  onTouchCancel: () => void;
  onTouchMove: () => void;
}

export function useLongPress(onLongPress: () => void, delay = 300): LongPressHandlers {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clear = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const onTouchStart = useCallback(
    (_e: React.TouchEvent) => {
      timerRef.current = setTimeout(() => {
        onLongPress();
      }, delay);
    },
    [onLongPress, delay]
  );

  return {
    onTouchStart,
    onTouchEnd: clear,
    onTouchCancel: clear,
    onTouchMove: clear,
  };
}
